import { Typography } from 'antd'
import React from 'react'

import { getNameLink } from '@/components/special-project-relations.component'
import { ResourceType, SubprojectWorkResourceType } from '@/schemas'

export const UserDetailTable: React.FC<{
  list: {
    project: {
      name: string
      selfId: string
      resourceType: ResourceType
    }
    subprojects?: {
      name: string
      selfId: string
      projectWorkload: number
      peopleWorkload: number
      percentage: number
      type: SubprojectWorkResourceType
    }[]
    projectWorkload: number
    peopleWorkload: number
    percentage: number
  }[]
}> = ({ list }) => {
  const startDate = new URLSearchParams(window.location.search).get('startDate')
  const endDate = new URLSearchParams(window.location.search).get('endDate')

  return (
    <div className='space-y-4 h-75 overflow-x-hidden overflow-y-auto'>
      {list.map((l) => (
        <div key={l.project.selfId}>
          <div className='flex font-medium text-base mb-2 justify-between'>
            <Typography.Text ellipsis={{ tooltip: l.project.name }}>
              {getNameLink({
                name: l.project.name,
                type: l.project.resourceType,
                selfId: l.project.selfId,
                params: { tab: 'dashboard', startDate, endDate },
              })}
            </Typography.Text>
            <div className='flex flex-shrink-0 ml-8'>
              <div>
                {l.projectWorkload} / {l.peopleWorkload}
              </div>
              <div className='text-right ml-2 w-20'>({(l.percentage * 100).toFixed(1)}%)</div>
            </div>
          </div>
          <div className='space-y-2 pl-2'>
            {(l.subprojects || []).map((p) => (
              <div key={p.selfId} className='flex justify-between'>
                <Typography.Text ellipsis={{ tooltip: p.name }}>
                  {p.type === SubprojectWorkResourceType.Project
                    ? getNameLink({
                        name: p.name,
                        type: ResourceType.PROJECT, // TODO 是否只有项目
                        selfId: p.selfId,
                        params: { tab: 'dashboard', startDate, endDate },
                      })
                    : getNameLink({
                        name: p.name,
                        type: l.project.resourceType,
                        selfId: l.project.selfId,
                        params: { tab: 'dashboard', startDate, endDate },
                      })}
                </Typography.Text>
                <div className='flex flex-shrink-0 ml-8'>
                  <div>
                    {p.projectWorkload} / {p.peopleWorkload}
                  </div>
                  <div className='text-right ml-2 w-20'>({(p.percentage * 100).toFixed(1)}%)</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
